import { interaction, SizableText, YStack } from '@mythical/ui'
import { SmartLink } from 'app/components/primitive/SmartLink'
import { SolitoImage } from 'solito/image'

export interface CollectionCardProps {
  id: string
  href: string
  image: string
  itemCount: number
  title: string
}

const CollectionCard = ({
  id,
  href,
  image,
  itemCount,
  title,
}: CollectionCardProps) => {
  return (
    <SmartLink
      Component={YStack}
      animation="medium"
      href={href}
      gap="$2"
      width="100%"
      $gtSm={{ gap: '$2.5' }}
      {...interaction.opacity}
    >
      <YStack
        ai="center"
        br="$2"
        jc="center"
        overflow="hidden"
        position="relative"
        width="100%"
      >
        <YStack width="100%" aspectRatio={1} position="relative">
          <SolitoImage
            alt={title || ''}
            contentFit="cover"
            fill
            sizes="(min-width: 660px) 277px, 170px"
            src={image}
          />
        </YStack>
      </YStack>

      <YStack gap="$1.5" $gtSm={{ gap: '$2' }}>
        {title && (
          <SizableText
            size="$1"
            color="$fgPrimary"
            fontWeight="500"
            $gtSm={{
              size: '$2',
              fontWeight: '500',
            }}
          >
            {title}
          </SizableText>
        )}

        {!!itemCount && (
          <SizableText
            size="$0.75"
            color="$fgSecondary"
            fontWeight="500"
            $gtSm={{
              size: '$1',
              fontWeight: '500',
            }}
          >
            {itemCount} {itemCount === 1 ? 'episode' : 'episodes'}
          </SizableText>
        )}
      </YStack>
    </SmartLink>
  )
}

export default CollectionCard
